module.exports = __webpack_public_path__ + "static/media/roastedbirchnut.ee8933de.webp";